import {myrequest} from 'network/myrequest.js'

//修改昵称
export function setusername(name,phone){
  return myrequest({
    url:'/users/username',
    method:"POST",
    data:{
      name,phone
    }
  })
}

//修改密码
export function cpassword(password,phone){
  return myrequest({
    url:'/users/cpsd',
    method:"POST",
    data:{
      password,phone
    }
  })
}

//签到
export function signin(dd,id){
  return myrequest({
    url:'/users/signin',
    method:"POST",
    data:{
      dd,id
    }
  })
}

//支付请求
export function support(phone,rmb){
  return myrequest({
    url:'/payment',
    method:"POST",
    data:{
      phone,rmb
    }
  })
}

//取消订单
export function delsupport(phone,tradeId){
  return myrequest({
    url:'/delpayment',
    method:"POST",
    data:{
      phone,tradeId
    }
  })
}

//查询订单
export function issupport(phone,tradeId,fee){
  return myrequest({
    url:'/ispayment',
    method:"POST",
    data:{
      phone,tradeId,fee
    }
  })
}

//查询所有订单
export function allsupport(phone){
  return myrequest({
    url:'/allpayment',
    method:"POST",
    data:{
      phone
    }
  })
}